import React from 'react'
import "./ReviewAndConfirmation.css"

const Inputbox = ({ label, type, placeholder,onChange,  status, ...props }) => {
  return (
    <div className="custom_input-container">
      <div className="input-label">
        {label}
      </div>
      {
        type === 'radio' ? (
          <div className='input-radio-options'>
            <div className="radio-option">
              <input
                type="radio"
                className="input-radio"
                checked={status === 'Yes'}
                onChange={onChange}
              />
              <span>Yes</span>
            </div>
            <div className="radio-option">
              <input
                type="radio"
                className="input-radio"
                checked={status === 'No'}
                onChange={onChange}
              />
              <span>No</span>
              
            </div>
          </div>
        ) : (
          <input className="input-box" placeholder={placeholder} {...props} />
        )

      }
    </div>
  )
}

export default Inputbox
